import { createRouteRef, createSubRouteRef } from '@mainstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-platform-settings',
});

export const practiceShaperRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-practice-shaper',
  parent: rootRouteRef,
  path: '/practice-shaper/*',
});

export const importPracticeShaperRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-practice-shaper-import',
  parent: rootRouteRef,
  path: '/practice-shaper/import',
});

export const graphPracticeShaperRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-practice-shaper-graph',
  parent: rootRouteRef,
  path: '/practice-shaper/graph',
});

export const supervisionRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-supervision',
  parent: rootRouteRef,
  path: '/supervision/*',
});

export const dynamicConfigRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-dynamic-config',
  parent: rootRouteRef,
  path: '/dynamic-config/*',
});

export const wittyAdministrationRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-witty-administration',
  parent: rootRouteRef,
  path: '/dynamic-config/witty',
});

export const wittyAgentsRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-witty-agents',
  parent: rootRouteRef,
  path: '/dynamic-config/witty/agents',
});

export const wittySkillsRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-witty-skills',
  parent: rootRouteRef,
  path: '/dynamic-config/witty/skills',
});

export const wittyMcpConnectionsRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-witty-mcp-connections',
  parent: rootRouteRef,
  path: '/dynamic-config/witty/mcp-servers',
});

export const wittyAgentDetailRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-witty-agent-detail',
  parent: rootRouteRef,
  path: '/dynamic-config/witty/agents/:agentId',
});

export const wittySkillDetailRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-witty-skill-detail',
  parent: rootRouteRef,
  path: '/dynamic-config/witty/skills/:skillId',
});

export const dynamicDataProvidersRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-descriptor-enrichment-providers',
  parent: rootRouteRef,
  path: '/descriptor-enrichment-providers/*',
});

export const customViewManagementRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-custom-view',
  parent: rootRouteRef,
  path: '/custom-view/*',
});

export const customViewDetailRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-custom-view-detail',
  parent: rootRouteRef,
  path: '/custom-view/:pageId',
});

export const customizationEditorRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-custom-view-editor',
  parent: rootRouteRef,
  path: '/custom-view/editor/:id',
});

export const builderToolsSkeletonRenderingPreviewRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-builder-tools-skeleton-rendering-preview',
  parent: rootRouteRef,
  path: '/builder-tools/skeleton-rendering-preview',
});

export const eventsDownloadRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-events-download',
  parent: rootRouteRef,
  path: '/events-download',
});

export const modulesRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-modules',
  parent: rootRouteRef,
  path: '/modules',
});

export const iamRouteRef = createSubRouteRef({
  id: 'iam',
  parent: rootRouteRef,
  path: '/iam',
});

export const templateIndexRouteRef = createSubRouteRef({
  id: 'templates',
  parent: rootRouteRef,
  path: '/templates',
});

export const templateImportRouteRef = createSubRouteRef({
  id: 'template-import',
  parent: rootRouteRef,
  path: '/templates/import',
});

export const actionsRouteRef = createSubRouteRef({
  id: 'actions',
  parent: rootRouteRef,
  path: '/templates/actions',
});

export const templateEditorRouteRef = createSubRouteRef({
  id: 'template-studio',
  parent: rootRouteRef,
  path: '/templates/template-studio',
});

export const taskRouteRef = createSubRouteRef({
  id: 'task',
  parent: rootRouteRef,
  path: '/templates/tasks/:taskId',
});

export const taskListRouteRef = createSubRouteRef({
  id: 'list-tasks',
  parent: rootRouteRef,
  path: '/templates/tasks',
});

export const developerToolsRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-developer-tools',
  parent: rootRouteRef,
  path: '/developer-tools/*',
});

export const eventTopicDetailRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-developer-tools-event-detail',
  parent: rootRouteRef,
  path: '/developer-tools/events/:topicId',
});

export const notificationKindDetailRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-developer-tools-notification-detail',
  parent: rootRouteRef,
  path: '/developer-tools/notifications/:kind',
});

export const workflowsRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-workflows',
  parent: rootRouteRef,
  path: '/workflows/*',
});

export const gitTokensRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-git-tokens',
  parent: rootRouteRef,
  path: '/dynamic-config/platform/git-tokens',
});

export const businessConceptModelManagementRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-business-concept-model',
  parent: rootRouteRef,
  path: '/dynamic-config/business-concept-models',
});

export const businessConceptModelDetailRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-business-concept-model-detail',
  parent: rootRouteRef,
  path: '/dynamic-config/business-concept-models/:modelId',
});

export const semanticContentManagementRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-semantic-content',
  parent: rootRouteRef,
  path: '/dynamic-config/semantic-content',
});
